import MangaCard from '@/components/feature/MangaCard';
import type { MangaItem } from '@/mocks/manga';

interface FeaturedSectionProps {
  mangaList: MangaItem[];
}

export default function FeaturedSection({ mangaList }: FeaturedSectionProps) {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">评分最高的韩国漫画精选</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {mangaList.map((manga) => (
            <MangaCard key={manga.slug} manga={manga} variant="compact" />
          ))}
        </div>
      </div>
    </section>
  );
}